import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import './directive';
import { getSocialSecurity as _getSocialSecurity, saveSocialSecurity } from 'api/payroll/salary-scheme/detail';
import { mapState } from 'vuex';
export default {
  props: {
    activeObj: {
      type: Object
    },
    isShow: {
      type: Boolean,
      default: true
    },
    isDisplay: {
      type: Boolean,
      default: false
    },
    id: {
      type: String
    }
  },
  data: function data() {
    return {
      activeNames: this.isShow ? [0, 1, 2] : [],
      activeInfo: this.activeObj ? this.activeObj.data.info : {},
      cActiveInfo: this.activeObj ? this.activeObj.data.cInfo : {} // 拷贝数据，判断是否修改
    };
  },

  computed: _objectSpread({}, mapState({
    // 货币
    currency: function currency(state) {
      return state.user.company_info.currency;
    }
  })),
  mounted: function mounted() {
    this.getSocialSecurity();
  },
  methods: {
    getSocialSecurity: function getSocialSecurity() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _getSocialSecurity({
                payroll_sub_project_scheme_id: _this.id || _this.$route.params.id
              });
            case 2:
              res = _context.sent;
              if (res && res.code === 1) {
                _this.activeInfo = Object.assign(_this.activeInfo, res.data);
                _this.cActiveInfo = JSON.parse(JSON.stringify(Object.assign(_this.cActiveInfo, res.data)));
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    saveData: function saveData() {
      return saveSocialSecurity(_objectSpread({
        payroll_sub_project_scheme_id: this.$route.params.id
      }, this.activeInfo));
    },
    social_security_base_min_blur: function social_security_base_min_blur() {
      var social_security_base_min = Number(this.activeInfo.social_security_base_min) || 0;
      var social_security_base_max = Number(this.activeInfo.social_security_base_max) || 0;
      if (social_security_base_max && social_security_base_min > social_security_base_max) {
        this.activeInfo.social_security_base_min = this.activeInfo.social_security_base_max;
      }
    },
    social_security_base_max_blur: function social_security_base_max_blur() {
      var social_security_base_min = Number(this.activeInfo.social_security_base_min) || 0;
      var social_security_base_max = Number(this.activeInfo.social_security_base_max) || 0;
      if (social_security_base_min && social_security_base_max < social_security_base_min) {
        this.activeInfo.social_security_base_max = this.activeInfo.social_security_base_min;
      }
    }
  }
};